import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import NavigationIcon from '@mui/icons-material/Navigation';
import { Box } from '@mui/material';
import PercentageBar from 'modules/Telematics/components/TelematicsRightPanel/Timeline/PercentageBar';
import {
	ALL_DRY_PATH_TAGS,
	TIMELINE_COLORS,
} from 'modules/Telematics/constants';
import {
	AllSegmentTypes,
	TimelineDataInterface,
} from 'modules/Telematics/types';
import moment from 'moment';
import { useState } from 'react';
import styles from './index.module.css';
interface Props {
	height: number;
	backgroundColor: string;
	startTime: string;
	duration: number;
	onClickTimeSegment: any;
	distance: number;
	areaInAcres: number | undefined;
	avgSpeed: number;
	maxSpeed: number;
	placeId: number | string;
	externalPowerDisconn: number;
	ignitionTamper: number;
	ignitionTamperWithMovement: number;
	lowBattery: number;
	batteryTamper: number;
	lowNetwork: number;
	highGEvent: number;
	rollover: number;
	internalTempRange: Array<number>;
	newDate: undefined | string;
}
const TimeSegment = (props: Props) => {
	const [showDetails, setShowDetails] = useState(false);
	return (
		<Box>
			<Box
				id="time-segment"
				sx={{
					display: 'flex',
					height: `${props.height}px`,
				}}
			>
				<Box
					id="hour-box"
					sx={{
						position: 'relative',
						minWidth: '60px',
						maxWidth: '60px',
						width: '60px',
						height: '100%',
						fontSize: '12px',
						color: 'gray',
					}}
				>
					<span>{props.startTime}</span>
					<Box
						id="segment-divider"
						sx={{
							position: 'absolute',
							right: '0',
							top: '0',
							height: '2px',
							width: props.newDate ? '100%' : '25%',
							background: 'grey',
						}}
					></Box>
					{props.newDate && (
						<Box
							id="next-date"
							sx={{
								position: 'absolute',
								right: '2px',
								top: '-32px',
								color: 'rgba(0,0,0,0.8)',
								fontWeight: '600',
								fontSize: '13px',
								lineHeight: '15px',
								fontStyle: 'italic',
							}}
						>
							{props.newDate}
						</Box>
					)}
				</Box>
				<Box
					id="time-segment-strip"
					sx={{
						minWidth: '20px',
						maxWidth: '20px',
						width: '20px',
						height: '100%',
						borderBottom: '1px solid white',
						background: props.backgroundColor,
					}}
				></Box>
				<Box
					id="booking-line-space"
					sx={{ minWidth: '20px', maxWidth: '20px', width: '20px' }}
				></Box>
				<Box
					id="segment-details"
					sx={{
						height: '100%',
						position: 'relative',
					}}
				>
					<Box id="details-line-1" sx={{ display: 'flex' }}>
						<Box
							id="distance"
							sx={{
								width: '100px',
								fontSize: '14px',
								opacity: '0.7',
								fontWeight: 'bold',
							}}
						>
							{props.distance} Kms
						</Box>
						<Box
							id="polygon-area"
							sx={{
								width: '100px',
								fontSize: '14px',
								opacity: '0.7',
								fontWeight: 'bold',
								visibility: props.areaInAcres
									? 'visible'
									: 'hidden',
							}}
						>
							{props.areaInAcres} Acres
						</Box>
						<Box
							onClick={props.onClickTimeSegment}
							sx={{
								marginLeft: '10px',
							}}
						>
							<NavigationIcon
								fontSize="small"
								color="primary"
								sx={{
									boxShadow: 'gray 1px 1px 1px 1px',
									cursor: 'pointer',
									transform: 'rotate(45deg)',
									height: '20px',
									width: '20px',
									border: '1px solid gray',
									borderRadius: '50px',
								}}
							/>
						</Box>
					</Box>
					<Box
						id="details-line-2"
						sx={{
							fontSize: '14px',
							opacity: '0.7',
						}}
					>
						<b>Duration</b>: {props.duration} min
					</Box>
					<Box
						id="details-line-3"
						sx={{
							marginTop: '5px',
							fontSize: '14px',
							opacity: '0.7',
						}}
					>
						<b>Speed</b>: {props.avgSpeed}-{props.maxSpeed}kmph
					</Box>
				</Box>
				<Box
					onClick={() => {
						setShowDetails((prev) => !prev);
					}}
					sx={{
						marginLeft: '10px',
						height: '100%',
						width: '20px',
						borderRadius: '20px',
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
					}}
				>
					{showDetails ? (
						<ExpandLessIcon
							sx={{
								cursor: 'pointer',
								borderRadius: '50px',
								':hover': {
									background: 'lightblue',
								},
							}}
						/>
					) : (
						<ExpandMoreIcon
							sx={{
								cursor: 'pointer',
								borderRadius: '50px',
								':hover': {
									background: 'lightblue',
								},
							}}
						/>
					)}
				</Box>
			</Box>
			<Box
				id="segment-metadata"
				className={showDetails ? styles.shownDiv : styles.hiddenDiv}
			>
				<Box
					id="metadata-offset1"
					sx={{
						minWidth: '80px',
						maxWidth: '80px',
						width: '80px',
						borderRight: '2px dotted rgba(0,0,0,0.5)',
					}}
				></Box>
				<Box
					id="metadata-offset2"
					sx={{
						minWidth: '20px',
						maxWidth: '20px',
						width: '20px',
					}}
				></Box>
				<Box
					sx={{
						'&>div': {
							fontSize: '13px',
						},
					}}
				>
					<Box display="flex" marginBottom="5px">
						<Box width="160px" marginRight="10px" color="gray">
							Place id:
						</Box>
						<Box>{props.placeId}</Box>
					</Box>
					<PercentageBar
						interpolatedPercentageForFillWidth={
							50 + props.externalPowerDisconn / 2
						}
						realPercentageForDisplay={props.externalPowerDisconn}
						fillColor="red"
						label="External power disconn"
					/>
					{/* <PercentageBar
						interpolatedPercentageForFillWidth={100}
						realPercentageForDisplay={100}
						fillColor="green"
						label="Movement"
					/>
					<PercentageBar
						interpolatedPercentageForFillWidth={100}
						realPercentageForDisplay={100}
						fillColor="red"
						label="Vibration"
					/> */}
					<PercentageBar
						interpolatedPercentageForFillWidth={
							50 + props.ignitionTamper / 2
						}
						realPercentageForDisplay={props.ignitionTamper}
						fillColor="red"
						label="Ignition Tamper"
					/>
					<PercentageBar
						interpolatedPercentageForFillWidth={
							50 + props.ignitionTamperWithMovement / 2
						}
						realPercentageForDisplay={
							props.ignitionTamperWithMovement
						}
						fillColor="red"
						label="Tamper + Movement"
					/>
					<PercentageBar
						interpolatedPercentageForFillWidth={
							50 + props.lowBattery / 2
						}
						realPercentageForDisplay={props.lowBattery}
						fillColor="red"
						label="Low Battery"
					/>
					<PercentageBar
						interpolatedPercentageForFillWidth={
							50 + props.batteryTamper / 2
						}
						realPercentageForDisplay={props.batteryTamper}
						fillColor="red"
						label="Battery Tampered"
					/>
					{/* <Box display="flex" marginBottom="5px">
						<Box width="160px" marginRight="10px" color="gray">
							Battery Temp:
						</Box>
						<Box> 50-70 deg cel</Box>
					</Box> */}
					<PercentageBar
						interpolatedPercentageForFillWidth={
							50 + props.lowNetwork / 2
						}
						realPercentageForDisplay={props.lowNetwork}
						fillColor="red"
						label="Low Network"
					/>
					<PercentageBar
						interpolatedPercentageForFillWidth={
							50 + props.highGEvent / 2
						}
						realPercentageForDisplay={props.highGEvent}
						fillColor="red"
						label="High G-Event"
					/>
					<PercentageBar
						interpolatedPercentageForFillWidth={
							50 + props.rollover / 2
						}
						realPercentageForDisplay={props.rollover}
						fillColor="red"
						label="Rollover"
					/>
					<Box display="flex" marginBottom="5px">
						<Box width="160px" marginRight="10px" color="gray">
							Temperature:
						</Box>
						<Box>
							{props.internalTempRange[0]}C to{' '}
							{props.internalTempRange[1]}C
						</Box>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

// Rollover : 0.0%
interface TimelineProps {
	combinedData: TimelineDataInterface[];
	onClickTimeSegment: any;
}
const getDurationInMinutes = (start: number, end: number) => {
	const startTimeMoment = moment(start);
	const endTimeMoment = moment(end);
	return moment.duration(endTimeMoment.diff(startTimeMoment)).minutes();
};

const getDistanceInKms = (segment: TimelineDataInterface) => {
	if (segment.tagData[ALL_DRY_PATH_TAGS.DISTANCE_TRAVELLED_METERS]) {
		const distance = segment.tagData[
			ALL_DRY_PATH_TAGS.DISTANCE_TRAVELLED_METERS
		] as number;
		return Number((distance / 1000).toFixed(3));
	}
	return 0;
};

const getAvgAndMaxSpeed = (segment: TimelineDataInterface) => {
	let tagAvgSpeed = segment.tagData[ALL_DRY_PATH_TAGS.AVERAGE_SPEED];
	let tagMaxSpeed = segment.tagData[ALL_DRY_PATH_TAGS.MAX_SPEED];
	let avgSpeed = 0;
	let maxSpeed = 0;
	if (tagAvgSpeed && (tagAvgSpeed as number) > 0) {
		avgSpeed = Number((tagAvgSpeed as number).toFixed(2));
	}
	if (tagMaxSpeed && (tagMaxSpeed as number) > 0) {
		maxSpeed = Number((tagMaxSpeed as number).toFixed(2));
	}
	return { avgSpeed, maxSpeed };
};

const getBackgroundColor = (segment: TimelineDataInterface) => {
	switch (segment.metadata.type) {
		case AllSegmentTypes.DRY_RUN_SEGMENT:
			return TIMELINE_COLORS.DRY_PATH_COLOR;
		case AllSegmentTypes.POLY_SEGMENT:
			return TIMELINE_COLORS.POLYGON_COLOR;
		case AllSegmentTypes.STANDING_EVENT:
			return TIMELINE_COLORS.STANDING_EVENT_COLOR;
		case AllSegmentTypes.PARKING_EVENT:
			return TIMELINE_COLORS.PARKING_COLOR;
		default:
			return 'gray';
	}
};
const getInternalTempRange = (segment: TimelineDataInterface) => {
	const minTemp = Math.ceil(
		segment.tagData[ALL_DRY_PATH_TAGS.MIN_INTERNAL_TEMPERATURE] as number,
	);
	const maxTemp = Math.ceil(
		segment.tagData[ALL_DRY_PATH_TAGS.MAX_INTERNAL_TEMPERATURE] as number,
	);
	return [minTemp, maxTemp];
};
const index = (props: TimelineProps) => {
	return (
		<Box marginTop="40px">
			{props.combinedData.map((segment, index) => {
				let newDate;
				if (index > 0) {
					const currentDay = moment(segment.startTime).date();
					const prevDay = moment(
						props.combinedData[index - 1].startTime,
					).date();
					if (currentDay !== prevDay) {
						newDate = moment(segment.startTime).format('ll');
					}
				}
				const duration = getDurationInMinutes(
					segment.startTime,
					segment.endTime,
				);
				const height = 110 + 20 * Math.log(duration);
				const distanceInKms = getDistanceInKms(segment);

				const areaInAcres = segment.AREA_IN_ACRES;
				const { avgSpeed, maxSpeed } = getAvgAndMaxSpeed(segment);
				const externalPowerDisconn = segment.tagData[
					ALL_DRY_PATH_TAGS.EXT_POWER_DISCONNECTED
				] as number;
				const ignitionTamper = segment.tagData[
					ALL_DRY_PATH_TAGS.IGNITION_WIRE_TAMPERED
				] as number;
				const ignitionTamperWithMovement = segment.tagData[
					ALL_DRY_PATH_TAGS.IGNITION_WIRE_TAMPERED_WITH_MOVEMENT
				] as number;
				const lowBattery = segment.tagData[
					ALL_DRY_PATH_TAGS.LOW_BATTERY_PERCENTAGE
				] as number;
				const batteryTamper = segment.tagData[
					ALL_DRY_PATH_TAGS.INTERNAL_BATTERY_TAMPERED_PERCENTAGE
				] as number;
				const lowNetwork = segment.tagData[
					ALL_DRY_PATH_TAGS.NETWORK_LOW_SIGNAL_STRENGTH
				] as number;
				const highGEvent = segment.tagData[
					ALL_DRY_PATH_TAGS.ACCIDENT_HIGH_G_FORCE
				] as number;
				const rollover = segment.tagData[
					ALL_DRY_PATH_TAGS.ACCIDENT_ROLLOVER
				] as number;
				const internalTempRange = getInternalTempRange(segment);
				return (
					<TimeSegment
						key={segment.metadata.placeId}
						onClickTimeSegment={() =>
							props.onClickTimeSegment(segment.metadata)
						}
						duration={duration}
						startTime={moment(segment.startTime).format('hh:mm a')}
						height={height}
						distance={distanceInKms}
						areaInAcres={areaInAcres}
						avgSpeed={avgSpeed}
						maxSpeed={maxSpeed}
						backgroundColor={getBackgroundColor(segment)}
						placeId={segment.metadata.placeId}
						externalPowerDisconn={Math.ceil(externalPowerDisconn)}
						ignitionTamper={Math.ceil(ignitionTamper)}
						ignitionTamperWithMovement={Math.ceil(
							ignitionTamperWithMovement,
						)}
						lowBattery={Math.ceil(lowBattery)}
						batteryTamper={Math.ceil(batteryTamper)}
						lowNetwork={Math.ceil(lowNetwork)}
						highGEvent={Math.ceil(highGEvent)}
						rollover={Math.ceil(rollover)}
						internalTempRange={internalTempRange}
						newDate={newDate}
					/>
				);
			})}
		</Box>
	);
};

export default index;
